import { PlayListRow } from 'components/player/PlayListRow';
import { chapterIndexAt } from 'helpers/audioJournal';
import { AudioChapter } from 'types';

/** An issue's chapters (articles), shown like the player's playlist. Tapping one plays from its start. */
export function ChapterList({
	chapters,
	position,
	onSelect,
	font = 'locale-hi',
}: {
	chapters: AudioChapter[];
	position: number;
	onSelect: (chapter: AudioChapter) => void;
	font?: string;
}) {
	const current = chapterIndexAt(chapters, position);

	return (
		<div role="list" aria-label="Chapters">
			{chapters.map((chapter, index) => (
				<PlayListRow
					key={`${chapter.articleId}-${index}`}
					role="listitem"
					data-testid="aj-chapter"
					aria-current={index === current ? 'true' : undefined}
					selected={index === current}
					last={index === chapters.length - 1}
					onClick={() => onSelect(chapter)}
					title={chapter.title}
					titleClass={font}
					subheader={`Chapter ${index + 1}`}
					length={Math.max(0, chapter.end - chapter.start)}
				/>
			))}
		</div>
	);
}
